interface IconProps {
  color?: string
}

export const Home = ({ color }: IconProps) => {
  return (
    <svg
      width="32"
      height="32"
      aria-hidden="true"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.62105 13.1601C2.34854 12.7666 2.44662 12.2267 2.84012 11.9541C6.11301 9.68756 10.5971 6.62827 13.2598 4.8155C14.915 3.68862 17.0886 3.69455 18.7395 4.82412L29.1563 11.9514C29.5513 12.2217 29.6524 12.761 29.3821 13.156C29.1119 13.5511 28.5725 13.6522 28.1775 13.3819L26.6669 12.3483V24C26.6669 26.2091 24.876 28 22.6669 28H9.33354C7.1244 28 5.33354 26.2091 5.33354 24V12.3386C4.81163 12.6982 4.30625 13.0472 3.82696 13.3791C3.43347 13.6516 2.89356 13.5536 2.62105 13.1601ZM13.7335 26.2666V17.3333C13.7335 16.8178 14.1514 16.4 14.6669 16.4H17.3335C17.849 16.4 18.2669 16.8178 18.2669 17.3333V26.2666H13.7335ZM20.0002 26.2666H22.6669C23.9187 26.2666 24.9335 25.2518 24.9335 24V11.1624L17.7607 6.25466C16.697 5.52685 15.299 5.52409 14.2353 6.2483C12.3844 7.5084 9.6558 9.36916 7.06687 11.1465V24C7.06687 25.2518 8.0817 26.2666 9.33354 26.2666H12.0002V17.3333C12.0002 15.8605 13.1941 14.6666 14.6669 14.6666H17.3335C18.8063 14.6666 20.0002 15.8605 20.0002 17.3333V26.2666Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
